export default function isPC() {
  const userAgentInfo = navigator.userAgent;
  const Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  let flag = true;
  const isSafari =
    userAgentInfo.indexOf("Safari") != -1 &&
    userAgentInfo.indexOf("Version") != -1;
  // 判断是否为ipad pro
  if (
    isSafari &&
    userAgentInfo.indexOf("Macintosh") &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2
  ) {
    return false;
  }
  for (let v = 0; v < Agents.length; v += 1) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
